export enum Platform {
  Windows = 0,
  MacOS = 1
}

export const platformTranslationMap: Record<Platform, string> = {
  [Platform.Windows]: 'Windows',
  [Platform.MacOS]: 'macOS'
};
